export const BID_STATUS_LIST_MUTATION = "BID_STATUS_LIST_MUTATION";
